// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pcf-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #5b67f8 0%, #715dfa 38%, #f8fafc 38%, #f8fafc 100%);
  padding: 64px 24px 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pcf-hero {
  width: 100%;
  max-width: 1080px;
  margin-bottom: 30px;
}

.pcf-hero-card {
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(8px);
  border-radius: 24px;
  padding: 40px 46px;
  color: #fff;
  box-shadow: 0 24px 65px -28px rgba(15, 23, 42, 0.45);
}

.pcf-hero-card h1 {
  margin: 0 0 16px;
  font-size: 2.1rem;
  line-height: 1.35;
}

.pcf-hero-description {
  margin: 0;
  opacity: 0.85;
}

.pcf-body {
  width: 100%;
  max-width: 1080px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.pcf-info-card {
  background: #fff;
  border-radius: 20px;
  padding: 30px 36px;
  box-shadow: 0 28px 70px -32px rgba(15, 23, 42, 0.32);
}

.pcf-client-card {
  background: #fff;
  border-radius: 20px;
  padding: 28px 34px;
  box-shadow: 0 24px 60px -30px rgba(15, 23, 42, 0.28);
}

.pcf-client-card h3 {
  margin: 0 0 16px;
  color: #1e293b;
}

.pcf-client-info-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 18px 32px;
}

.pcf-client-info-item {
  min-width: 160px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pcf-client-label {
  font-size: 0.8rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.pcf-client-value {
  font-weight: 600;
  color: #0f172a;
}

.pcf-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
}

.pcf-info-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
}

.pcf-info-card h3 {
  margin: 0;
  color: #1e293b;
  font-size: 1.1rem;
}

.pcf-rep-photo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e5e7eb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.pcf-firm-logo {
  max-width: 140px;
  max-height: 70px;
  object-fit: contain;
  border-radius: 10px;
  border: 1.5px solid #e5e7eb;
  background: #ffffff;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}

.pcf-info-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px 22px;
}

.pcf-info-grid > div:nth-child(3),
.pcf-info-grid > div:nth-child(4) {
  justify-self: flex-end;
  text-align: right;
}

.pcf-info-full {
  grid-column: 1 / -1;
  text-align: left;
}

.pcf-info-label {
  display: block;
  font-size: 0.85rem;
  color: #64748b;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.pcf-info-value {
  font-weight: 600;
  color: #0f172a;
}

.pcf-message {
  border-radius: 16px;
  padding: 18px 20px;
  font-weight: 500;
}

.pcf-message.success {
  background: #ecfdf5;
  color: #047857;
}

.pcf-message.error {
  background: #fee2e2;
  color: #b91c1c;
}

.pcf-form-card {
  background: #fff;
  border-radius: 24px;
  padding: 32px 40px 40px;
  box-shadow: 0 30px 80px -36px rgba(15, 23, 42, 0.35);
}

.pcf-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px 28px;
}

.pcf-field {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pcf-field.full-width {
  grid-column: 1 / -1;
}

.pcf-field label {
  font-weight: 600;
  color: #0f172a;
}

.pcf-field input,
.pcf-field textarea,
.pcf-field select {
  width: 100%;
  border: 1px solid #cbd5f5;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 1rem;
  transition: border 0.2s ease, box-shadow 0.2s ease;
  background: #f8fafc;
}

.pcf-field input:focus,
.pcf-field textarea:focus,
.pcf-field select:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.22);
  background: #fff;
}

.pcf-field textarea {
  min-height: 140px;
  resize: vertical;
}

.pcf-checkbox-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px 18px;
}

.pcf-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.95rem;
  color: #334155;
  line-height: 1.35;
}

.pcf-checkbox input {
  margin-top: 6px;
}

.pcf-submit-row {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-top: 10px;
}

.pcf-terms {
  flex: 1 1;
  margin: 0;
}

.pcf-terms a {
  color: #2563eb;
  text-decoration: none;
  font-weight: 600;
}

.pcf-terms a:hover {
  text-decoration: underline;
}

.pcf-submit {
  width: 240px;
  align-self: flex-end;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border: none;
  border-radius: 12px;
  color: #fff;
  padding: 16px 18px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.pcf-submit:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 28px -16px rgba(99, 102, 241, 0.6);
}

.pcf-submit:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.pcf-field.table-field {
  margin-top: 10px;
}

.pcf-table {
  border-radius: 14px;
  border: 1px solid #e0e7ff;
  background: #f8fbff;
  overflow: hidden;
}

.pcf-table-scroll {
  overflow-x: auto;
}

.pcf-table-header,
.pcf-table-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  min-width: 560px;
}

.pcf-table-header {
  background: #f1f5ff;
  font-weight: 600;
  font-size: 0.92rem;
  color: #1e293b;
}

.pcf-table-header .pcf-table-cell,
.pcf-table-row .pcf-table-cell {
  padding: 14px 16px;
  border-bottom: 1px solid #e2e8f0;
}

.pcf-table-row .pcf-table-cell input {
  width: 100%;
  border: 1px solid #cbd5f5;
  border-radius: 10px;
  padding: 10px 12px;
  background: #fff;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}

.pcf-table-row .pcf-table-cell input:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.18);
}

.pcf-table-row:last-child .pcf-table-cell {
  border-bottom: none;
}

.pcf-page-success {
  justify-content: center;
  padding: 48px 24px;
}

.pcf-page-success .pcf-message {
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: 0 26px 70px -34px rgba(15, 23, 42, 0.28);
}

.pcf-page-success .pcf-message h2 {
  margin-bottom: 12px;
  font-size: 1.8rem;
}

@media (max-width: 1024px) {
  .pcf-form-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .pcf-submit-row {
    flex-direction: column;
    align-items: stretch;
  }

  .pcf-submit {
    width: 100%;
  }

  .pcf-info-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    text-align: left;
  }

  .pcf-info-grid > div:nth-child(3),
  .pcf-info-grid > div:nth-child(4) {
    justify-self: flex-start;
    text-align: left;
  }

  /* Tablet: 2-column checkbox layout */
  .pcf-checkbox-group {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}

@media (max-width: 640px) {
  .pcf-page {
    padding: 40px 16px 60px;
  }

  .pcf-hero-card {
    padding: 28px;
  }

  .pcf-form-card {
    padding: 24px 20px 28px;
  }

  .pcf-info-card {
    padding: 22px;
  }

  .pcf-info-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .pcf-info-header-left {
    width: 100%;
    gap: 12px;
  }

  .pcf-rep-photo {
    width: 64px;
    height: 64px;
  }

  .pcf-firm-logo {
    max-width: 110px;
    max-height: 55px;
    align-self: flex-start;
  }

  .pcf-info-card h3 {
    font-size: 1rem;
  }

  .pcf-table-header,
  .pcf-table-row {
    min-width: 440px;
  }

  .pcf-info-grid {
    grid-template-columns: 1fr;
  }

  .pcf-hero-card h1 {
    font-size: 1.6rem;
  }

  .pcf-field textarea {
    min-height: 120px;
  }

  /* Mobile-optimized form fields */
  .pcf-field {
    gap: 8px;
  }

  .pcf-field label {
    font-size: 0.95rem;
    line-height: 1.4;
  }

  /* Larger touch targets for mobile */
  .pcf-field input,
  .pcf-field textarea,
  .pcf-field select {
    padding: 14px 16px;
    font-size: 16px; /* Prevents zoom on iOS */
    border-radius: 10px;
  }

  /* Checkbox optimizations for mobile */
  .pcf-checkbox-group {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .pcf-checkbox {
    padding: 12px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    transition: all 0.2s ease;
  }

  .pcf-checkbox input {
    width: 20px;
    height: 20px;
    margin-top: 2px;
  }

  .pcf-checkbox:active {
    background: #f1f5f9;
    border-color: #cbd5e1;
  }

  /* Select dropdowns optimized for mobile */
  .pcf-field select {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right 12px center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
    padding-right: 40px;
  }

  /* Submit button mobile optimization */
  .pcf-submit {
    padding: 18px 20px;
    font-size: 1.05rem;
    border-radius: 10px;
  }
}

@media (max-width: 768px) {
  .pcf-page-success {
    padding: 32px 20px;
  }

  /* Tablet: Single column layout with better spacing */
  .pcf-form-grid {
    gap: 16px;
  }

  .pcf-hero-card h1 {
    font-size: 1.75rem;
  }

  .pcf-hero-card p {
    font-size: 0.95rem;
  }
}

/* iOS-specific optimizations */
@supports (-webkit-touch-callout: none) {
  .pcf-field input,
  .pcf-field textarea,
  .pcf-field select {
    font-size: 16px; /* Prevents auto-zoom on iOS */
  }
}

/* Extra small devices (phones < 375px) */
@media (max-width: 374px) {
  .pcf-page {
    padding: 32px 12px 48px;
  }

  .pcf-hero-card {
    padding: 24px;
  }

  .pcf-form-card {
    padding: 20px 16px 24px;
  }

  .pcf-hero-card h1 {
    font-size: 1.4rem;
  }

  .pcf-field label {
    font-size: 0.9rem;
  }

  .pcf-checkbox {
    padding: 10px;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PublicConsultationForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uFAAuF;EACvF,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gDAAgD;IAChD,gBAAgB;EAClB;;EAEA;;IAEE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA,qCAAqC;EACrC;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,oCAAoC;EACpC;;;IAGE,kBAAkB;IAClB,eAAe,EAAE,yBAAyB;IAC1C,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA,0CAA0C;EAC1C;IACE,yDAAmP;IACnP,sCAAsC;IACtC,4BAA4B;IAC5B,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA,qDAAqD;EACrD;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE;;;IAGE,eAAe,EAAE,8BAA8B;EACjD;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":[".pcf-page {\n  min-height: 100vh;\n  background: linear-gradient(180deg, #5b67f8 0%, #715dfa 38%, #f8fafc 38%, #f8fafc 100%);\n  padding: 64px 24px 90px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.pcf-hero {\n  width: 100%;\n  max-width: 1080px;\n  margin-bottom: 30px;\n}\n\n.pcf-hero-card {\n  background: rgba(255, 255, 255, 0.18);\n  backdrop-filter: blur(8px);\n  border-radius: 24px;\n  padding: 40px 46px;\n  color: #fff;\n  box-shadow: 0 24px 65px -28px rgba(15, 23, 42, 0.45);\n}\n\n.pcf-hero-card h1 {\n  margin: 0 0 16px;\n  font-size: 2.1rem;\n  line-height: 1.35;\n}\n\n.pcf-hero-description {\n  margin: 0;\n  opacity: 0.85;\n}\n\n.pcf-body {\n  width: 100%;\n  max-width: 1080px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.pcf-info-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 30px 36px;\n  box-shadow: 0 28px 70px -32px rgba(15, 23, 42, 0.32);\n}\n\n.pcf-client-card {\n  background: #fff;\n  border-radius: 20px;\n  padding: 28px 34px;\n  box-shadow: 0 24px 60px -30px rgba(15, 23, 42, 0.28);\n}\n\n.pcf-client-card h3 {\n  margin: 0 0 16px;\n  color: #1e293b;\n}\n\n.pcf-client-info-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px 32px;\n}\n\n.pcf-client-info-item {\n  min-width: 160px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pcf-client-label {\n  font-size: 0.8rem;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.pcf-client-value {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.pcf-info-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 20px;\n}\n\n.pcf-info-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.pcf-info-card h3 {\n  margin: 0;\n  color: #1e293b;\n  font-size: 1.1rem;\n}\n\n.pcf-rep-photo {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid #e5e7eb;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  flex-shrink: 0;\n}\n\n.pcf-firm-logo {\n  max-width: 140px;\n  max-height: 70px;\n  object-fit: contain;\n  border-radius: 10px;\n  border: 1.5px solid #e5e7eb;\n  background: #ffffff;\n  padding: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  flex-shrink: 0;\n}\n\n.pcf-info-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px 22px;\n}\n\n.pcf-info-grid > div:nth-child(3),\n.pcf-info-grid > div:nth-child(4) {\n  justify-self: flex-end;\n  text-align: right;\n}\n\n.pcf-info-full {\n  grid-column: 1 / -1;\n  text-align: left;\n}\n\n.pcf-info-label {\n  display: block;\n  font-size: 0.85rem;\n  color: #64748b;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.pcf-info-value {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.pcf-message {\n  border-radius: 16px;\n  padding: 18px 20px;\n  font-weight: 500;\n}\n\n.pcf-message.success {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.pcf-message.error {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.pcf-form-card {\n  background: #fff;\n  border-radius: 24px;\n  padding: 32px 40px 40px;\n  box-shadow: 0 30px 80px -36px rgba(15, 23, 42, 0.35);\n}\n\n.pcf-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 22px 28px;\n}\n\n.pcf-field {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pcf-field.full-width {\n  grid-column: 1 / -1;\n}\n\n.pcf-field label {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.pcf-field input,\n.pcf-field textarea,\n.pcf-field select {\n  width: 100%;\n  border: 1px solid #cbd5f5;\n  border-radius: 12px;\n  padding: 12px 14px;\n  font-size: 1rem;\n  transition: border 0.2s ease, box-shadow 0.2s ease;\n  background: #f8fafc;\n}\n\n.pcf-field input:focus,\n.pcf-field textarea:focus,\n.pcf-field select:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.22);\n  background: #fff;\n}\n\n.pcf-field textarea {\n  min-height: 140px;\n  resize: vertical;\n}\n\n.pcf-checkbox-group {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px 18px;\n}\n\n.pcf-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 0.95rem;\n  color: #334155;\n  line-height: 1.35;\n}\n\n.pcf-checkbox input {\n  margin-top: 6px;\n}\n\n.pcf-submit-row {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.pcf-terms {\n  flex: 1;\n  margin: 0;\n}\n\n.pcf-terms a {\n  color: #2563eb;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.pcf-terms a:hover {\n  text-decoration: underline;\n}\n\n.pcf-submit {\n  width: 240px;\n  align-self: flex-end;\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  border: none;\n  border-radius: 12px;\n  color: #fff;\n  padding: 16px 18px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.pcf-submit:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 28px -16px rgba(99, 102, 241, 0.6);\n}\n\n.pcf-submit:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.pcf-field.table-field {\n  margin-top: 10px;\n}\n\n.pcf-table {\n  border-radius: 14px;\n  border: 1px solid #e0e7ff;\n  background: #f8fbff;\n  overflow: hidden;\n}\n\n.pcf-table-scroll {\n  overflow-x: auto;\n}\n\n.pcf-table-header,\n.pcf-table-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  min-width: 560px;\n}\n\n.pcf-table-header {\n  background: #f1f5ff;\n  font-weight: 600;\n  font-size: 0.92rem;\n  color: #1e293b;\n}\n\n.pcf-table-header .pcf-table-cell,\n.pcf-table-row .pcf-table-cell {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.pcf-table-row .pcf-table-cell input {\n  width: 100%;\n  border: 1px solid #cbd5f5;\n  border-radius: 10px;\n  padding: 10px 12px;\n  background: #fff;\n  transition: border 0.2s ease, box-shadow 0.2s ease;\n}\n\n.pcf-table-row .pcf-table-cell input:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.18);\n}\n\n.pcf-table-row:last-child .pcf-table-cell {\n  border-bottom: none;\n}\n\n.pcf-page-success {\n  justify-content: center;\n  padding: 48px 24px;\n}\n\n.pcf-page-success .pcf-message {\n  max-width: 420px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 26px 70px -34px rgba(15, 23, 42, 0.28);\n}\n\n.pcf-page-success .pcf-message h2 {\n  margin-bottom: 12px;\n  font-size: 1.8rem;\n}\n\n@media (max-width: 1024px) {\n  .pcf-form-grid {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .pcf-submit-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pcf-submit {\n    width: 100%;\n  }\n\n  .pcf-info-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    text-align: left;\n  }\n\n  .pcf-info-grid > div:nth-child(3),\n  .pcf-info-grid > div:nth-child(4) {\n    justify-self: flex-start;\n    text-align: left;\n  }\n\n  /* Tablet: 2-column checkbox layout */\n  .pcf-checkbox-group {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n}\n\n@media (max-width: 640px) {\n  .pcf-page {\n    padding: 40px 16px 60px;\n  }\n\n  .pcf-hero-card {\n    padding: 28px;\n  }\n\n  .pcf-form-card {\n    padding: 24px 20px 28px;\n  }\n\n  .pcf-info-card {\n    padding: 22px;\n  }\n\n  .pcf-info-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .pcf-info-header-left {\n    width: 100%;\n    gap: 12px;\n  }\n\n  .pcf-rep-photo {\n    width: 64px;\n    height: 64px;\n  }\n\n  .pcf-firm-logo {\n    max-width: 110px;\n    max-height: 55px;\n    align-self: flex-start;\n  }\n\n  .pcf-info-card h3 {\n    font-size: 1rem;\n  }\n\n  .pcf-table-header,\n  .pcf-table-row {\n    min-width: 440px;\n  }\n\n  .pcf-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .pcf-hero-card h1 {\n    font-size: 1.6rem;\n  }\n\n  .pcf-field textarea {\n    min-height: 120px;\n  }\n\n  /* Mobile-optimized form fields */\n  .pcf-field {\n    gap: 8px;\n  }\n\n  .pcf-field label {\n    font-size: 0.95rem;\n    line-height: 1.4;\n  }\n\n  /* Larger touch targets for mobile */\n  .pcf-field input,\n  .pcf-field textarea,\n  .pcf-field select {\n    padding: 14px 16px;\n    font-size: 16px; /* Prevents zoom on iOS */\n    border-radius: 10px;\n  }\n\n  /* Checkbox optimizations for mobile */\n  .pcf-checkbox-group {\n    grid-template-columns: 1fr;\n    gap: 14px;\n  }\n\n  .pcf-checkbox {\n    padding: 12px;\n    background: #f8fafc;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    transition: all 0.2s ease;\n  }\n\n  .pcf-checkbox input {\n    width: 20px;\n    height: 20px;\n    margin-top: 2px;\n  }\n\n  .pcf-checkbox:active {\n    background: #f1f5f9;\n    border-color: #cbd5e1;\n  }\n\n  /* Select dropdowns optimized for mobile */\n  .pcf-field select {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n    background-position: right 12px center;\n    background-repeat: no-repeat;\n    background-size: 1.5em 1.5em;\n    padding-right: 40px;\n  }\n\n  /* Submit button mobile optimization */\n  .pcf-submit {\n    padding: 18px 20px;\n    font-size: 1.05rem;\n    border-radius: 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .pcf-page-success {\n    padding: 32px 20px;\n  }\n\n  /* Tablet: Single column layout with better spacing */\n  .pcf-form-grid {\n    gap: 16px;\n  }\n\n  .pcf-hero-card h1 {\n    font-size: 1.75rem;\n  }\n\n  .pcf-hero-card p {\n    font-size: 0.95rem;\n  }\n}\n\n/* iOS-specific optimizations */\n@supports (-webkit-touch-callout: none) {\n  .pcf-field input,\n  .pcf-field textarea,\n  .pcf-field select {\n    font-size: 16px; /* Prevents auto-zoom on iOS */\n  }\n}\n\n/* Extra small devices (phones < 375px) */\n@media (max-width: 374px) {\n  .pcf-page {\n    padding: 32px 12px 48px;\n  }\n\n  .pcf-hero-card {\n    padding: 24px;\n  }\n\n  .pcf-form-card {\n    padding: 20px 16px 24px;\n  }\n\n  .pcf-hero-card h1 {\n    font-size: 1.4rem;\n  }\n\n  .pcf-field label {\n    font-size: 0.9rem;\n  }\n\n  .pcf-checkbox {\n    padding: 10px;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
